export enum ApiStatus {
  OK,
  Error,
  OutOfTime,
  AccessDenied,
  Success,
  InValidToken,
  AccountInActive,
}

export enum ErrorCodes {
  //DB_VALIDATION
  DBVALIDATION,
}
